<template>
    <div style="background-color:rgb(204 204 204 / 0.25);;padding:20px">
        <div style="display:flex;justify-content: center;padding-bottom:30px">
            <h3>Store Information</h3>
        </div>

        <a-form-model
                ref="AddStoreInfoform"
                :model="storeInfoform"
                :rules="rules"
            >
                <a-row type="flex" justify="space-around">
                    <a-col :span="20">
                        <a-form-model-item label="Store Type" ref="storeType" prop="storeType">
                            <a-select v-model="storeInfoform.storeType" placeholder="please enter your storetype">
                                <a-select-option value="0">
                                    Storage Only
                                </a-select-option>
                                <a-select-option value="1">
                                    Open to Sale
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-around">
                    <a-col :span="8" >
                        <a-form-model-item label="Is the Storage Lockable?" ref="lockableStorage" prop="lockableStorage">
                            <a-select v-model="storeInfoform.lockableStorage" placeholder="please select your option">
                                <a-select-option value="true">
                                    Yes
                                </a-select-option>
                                <a-select-option value="false">
                                    No
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                       <a-form-model-item label="What is the Storage Room size" ref="storageSize" prop="storageSize">
                            <a-input
                                v-model="storeInfoform.storageSize"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row type="flex" justify="space-around">
                    <a-col :span="8" >
                        <a-form-model-item label="Do You Have Refrigerators" ref="hasRefrigerator" prop="hasRefrigerator">
                            <a-select @change="onChangeHasRefrigerators" v-model="storeInfoform.hasRefrigerator" placeholder="please select your option">
                                <a-select-option value="true">
                                    Yes
                                </a-select-option>
                                <a-select-option value="false">
                                    No
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                       <a-form-model-item v-if="hasRefrigerators" label="What is the Source Energy for the Fridge?" ref="energySources" prop="energySources">
                            <a-select
                                mode="multiple"
                                style="width: 100%"
                                v-model="storeInfoform.energySources"
                                placeholder="please select your option"

                            >
                                <a-select-option v-for="i in energySourcesList" :key="i">
                                        {{ i }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-around">
                    <a-col :span="8" >
                        <a-form-model-item label="Do You Have a Backup Energy Supply?" ref="hasBackupEnergy" prop="hasBackupEnergy">
                            <a-select @change="onChangeHasBackupEnergy" v-model="storeInfoform.hasBackupEnergy" placeholder="please select your option">
                                <a-select-option value="true">
                                    Yes
                                </a-select-option>
                                <a-select-option value="false">
                                    No
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                       <a-form-model-item v-if="hasBackupEnergy" label="What Do You Use As Backup Energy Supply?" ref="backupEnergySources" prop="backupEnergySources">
                            <a-select
                                mode="multiple"
                                style="width: 100%"
                                v-model="storeInfoform.backupEnergySources"
                                placeholder="please select your option"
                            >
                                <a-select-option v-for="i in energySourcesList" :key="i">
                                        {{ i }}
                                </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                    <a-spin class="spinner" :spinning="loading" />
                </div>

            <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:50px;">
                <a-button @click="handleSubmit"  style="background: #418a49;height:45px;color:#fff;width:256px;">
                    Save
                </a-button>
            </a-form-model-item>
            </a-form-model>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
    export default {
        name: "StoreInfo",
        data(){
            return{
                storeInfoform:{
                    storeType:'',
                    storageSize:'',
                    hasRefrigerator:'',
                    hasBackupEnergy:'',
                    lockableStorage:'',
                    energySources:[],
                    backupEnergySources:[]
                },
                hasRefrigerators: false,
                hasBackupEnergy:false,
                energySourcesList: ['Grid', 'Solar', 'Other'],
                loading:false,
                rules: {
                    storeType: [
                        { required: true, message: 'Please enter your storetype' , trigger: 'change'},

                    ],
                    region: [
                        { required: true, message: 'Please choose your option' , trigger: 'change'},

                    ],
                    hasBackupEnergy: [
                        { required: true, message: 'Please choose your option' , trigger: 'change'},

                    ],
                    lockableStorage: [
                        { required: true, message: 'Please choose your option' , trigger: 'change'},

                    ],
                    energySources: [
                        { required: true, message: 'Please choose your option' , trigger: 'change'},

                    ],
                    backupEnergySources: [
                        { required: true, message: 'Please choose your option' , trigger: 'change'},

                    ],
                    hasRefrigerator: [
                        { required: true, message: 'Please choose your option' , trigger: 'change'},

                    ],
                    district: [
                        { required: true, message: 'Please choose your option' , trigger: 'change'},

                    ],
                    storageSize: [
                        { required: true, message: 'Please enter your storage size', trigger: 'change' },
                        {
                            pattern: new RegExp(/^[1-9]\d*$/),
                            message: 'Please enter valid number',
                            trigger: 'change'
                        },
                    ],

                },
            }
        },
        computed: mapGetters(['getStoreInfo','getCompanyInfo','getBusinessInfo']),
        methods:{
            ...mapActions(['setStepCount','setStoreInfo','getAllRegion','getDistrictById','addOnboardingInfo']),
            handleSubmit(){
                this.$refs.AddStoreInfoform.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let storeCompany_request_data = {
                        ownerName: this.getBusinessInfo.ownerName,
												age:parseInt(this.getBusinessInfo.age),
												businessName: this.getCompanyInfo.companyName,
                        gender:this.getBusinessInfo.gender,
                        ownerMobile:this.getBusinessInfo.ownerMobile,
                        educationLevel:parseInt(this.getBusinessInfo.educationLevel),
                        fieldOfTraining:this.getBusinessInfo.fieldOfTraining,
                        yearsInBusiness:parseInt(this.getBusinessInfo.yearsInBusiness),
                        numberOfStores:parseInt(this.getBusinessInfo.numberOfStores),
                        registrarGeneralYear: this.getCompanyInfo.yearOfRegistration + '-01-01',
                        registrationNumber:this.getCompanyInfo.businessRegNumber,
                        registeredVeterinary:this.getCompanyInfo.vetCouncil === "true" ? true : false,
                        registeredVeterinaryYear:this.getCompanyInfo.vetCouncilYearOfReg + '-01-01',
                        registrationStatus: this.getCompanyInfo.vetCouncilRegState === "" ? "" : parseInt(this.getCompanyInfo.vetCouncilRegState),
                        tin:this.getCompanyInfo.tin,
                        communityId: this.getCompanyInfo.town,
                        numberOfStaff: parseInt(this.getCompanyInfo.numberOfStaffs) ,
                        storeType: parseInt(this.storeInfoform.storeType),
                        lockableStorage: this.storeInfoform.lockableStorage === "true" ? true : false,
                        storageSize: parseInt(this.storeInfoform.storageSize),
                        hasRefrigerator: this.storeInfoform.hasRefrigerator === "true" ? true : false,
                        energySources: this.storeInfoform.energySources,
                        hasBackupEnergy: this.storeInfoform.hasBackupEnergy === "true" ? true : false,
                        backupEnergySources: this.storeInfoform.backupEnergySources,
                    }
                    // console.log("storeCompany_request_data | ", storeCompany_request_data)
                     this.addOnboardingInfo(storeCompany_request_data).then(response => {
                         this.loading = false;
                         if(response.status === 200){
                            this.setStoreInfo(this.storeInfoform)
                            this.setStepCount(3)
                            this.$router.push(`/product-info`).catch(()=>{});
                         }else if(response.status === 400){
                            this.loading = false;
                            this.showErrorAlert("Something went wrong, try again later")
                        }else{
                            this.loading = false;
                            this.showErrorAlert(response.data.messages)
                        }
                     },
                     error =>{
                        this.loading = false
                        this.showErrorAlert(JSON.stringify(error))
                    })
                    }else {
                        return false;
                    }
                })
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            handleChange(value) {
                console.log(`selected ${value}`);
                console.log(`storeInfoform ${this.storeInfoform.energySources}`);
            },
            onChangeHasRefrigerators(value){
                if(value === "true"){
                    this.hasRefrigerators = true
                }else{
                    this.hasRefrigerators = false
                }
            },
            onChangeHasBackupEnergy(value){
                if(value === "true"){
                    this.hasBackupEnergy = true
                }else{
                    this.hasBackupEnergy = false
                }
            },

        },
        created(){

            // console.log("getStoreInfo | ", this.getStoreInfo)
            if(this.getStoreInfo){
                this.onChangeHasRefrigerators(this.getStoreInfo.hasRefrigerator)
                this.onChangeHasBackupEnergy(this.getStoreInfo.hasBackupEnergy)
                this.storeInfoform = {
                    storeType:this.getStoreInfo.storeType,
                    storageSize:this.getStoreInfo.storageSize,
                    hasRefrigerator:this.getStoreInfo.hasRefrigerator,
                    hasBackupEnergy:this.getStoreInfo.hasBackupEnergy,
                    lockableStorage:this.getStoreInfo.lockableStorage,
                    energySources:this.getStoreInfo.energySources,
                    backupEnergySources:this.getStoreInfo.backupEnergySources
                }
            }
        }
    }
</script>

<style scoped>
.img_size{
    max-width: 56px;
    max-height: 55px;
}
</style>